<button
    class="flex w-full flex-1 items-center gap-x-8 rounded-full"
    type="button"
    [disabled]="disabled()"
    [ngClass]="{
        'opacity-50': disabled(),
        'cursor-default': disabled() || memberClickBehavior() === 'none',
    }"
    (click)="selectMember()"
>
    <interacta-member-avatar [member]="member()" />

    <div class="flex flex-col text-start">
        <div class="line-clamp-1 typo-sm-bold break-all">
            {{ member() | memberFullname }}
        </div>
        <div class="line-clamp-1 typo-xs break-all text-text-mid-contrast">
            @if (infoTemplate()) {
                <ng-template
                    *ngTemplateOutlet="infoTemplate(); context: member()"
                />
            } @else {
                @if (customInfo()) {
                    <div [matTooltip]="customInfo()">
                        {{ customInfo() }}
                    </div>
                } @else {
                    <!-- USER -->
                    @let user = member() | apply: getMemberUser;
                    @if (user && user.contactEmail) {
                        {{ user.contactEmail }}
                    }

                    @if (member() | apply: isMemberGroup) {
                        <!-- GROUP -->
                        <ng-container
                            *ngTemplateOutlet="
                                memberGroupTemplate;
                                context: member()
                            "
                        />
                    }
                }
            }
        </div>
    </div>
</button>

<ng-template #memberGroupTemplate let-group="group">
    @if (group.membersCount !== undefined) {
        <span>
            {{
                'SHARED.USER.USERS_COUNTER'
                    | translate
                        : {
                              counter: group.membersCount,
                          }
            }}
        </span>
    } @else {
        @if (group.tags?.length) {
            <div
                class="flex flex-wrap items-center gap-4"
                [ngClass]="{
                    'opacity-50': disabled(),
                }"
            >
                @for (tag of group.tags; track tag.id) {
                    <interacta-group-tag [label]="tag.name" [size]="'small'" />
                }
            </div>
        }
    }
</ng-template>
